import { Divider, useTheme } from '@mui/material';

export const NavDivider = () => {
  const { palette } = useTheme();
  return (
    <Divider
      sx={{
        ml: 1,
        mr: 2,
        my: 2,
        backgroundColor: palette.background.default,
        borderColor: palette.background.default,
      }}
    />
  );
};
